export const KB = 1024
export const MB = 1024 * 1024
export const GB = 1024 * 1024 * 1024
export const TB = 1024 * 1024 * 1024 * 1024